import React from 'react';
import BaseInput from './base-input';

interface TextInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  name?: string;
  autoComplete?: string;
  size?: 'sm' | 'md';
}

const TextInput: React.FC<TextInputProps> = ({
  value,
  onChange,
  placeholder,
  className = '',
  name,
  autoComplete,
  size = 'md',
}) => {
  return (
    <BaseInput className={className} size={size}>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        name={name}
        autoComplete={autoComplete}
        className="flex-1 min-w-0 outline-none bg-transparent text-[16px] leading-[24px] h-[24px] text-[#525866] placeholder:text-[16px] placeholder:text-[#525866]"
      />
    </BaseInput>
  );
};

export default TextInput;


